// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__2e0He","alertIcon":"ConfirmModal_alertIcon__1_6O2"};